import _isEmpty from 'lodash/isEmpty';
import _sortedIndexBy from 'lodash/sortedIndexBy';
import _sortBy from 'lodash/sortBy';
import _toLower from 'lodash/toLower';
import _remove from 'lodash/remove';
import _findIndex from 'lodash/findIndex';
import _get from 'lodash/get';
import {PROJECTS} from '../constants';

/**
 * @desc  SchoolCommonRoomService class.
 * @ngInject
 */
export default class SchoolCommonRoomService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   * @param {$localStorage} $localStorage
   * @param {UtilService} UtilService
   */
  constructor(
    $rootScope, $q, $log, $http, $localStorage,
    UtilService
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.UtilService = UtilService;

    this.allSchoolCommonRooms = [];
    this.schoolCommonRooms = [];
    this.currentSchoolCommonRoom = {};
    this.me = {};
    this.getMePromise = null;

    this.$rootScope.$on('SCR.change', () => {
      this.currentSchoolCommonRoom = {};
      this.me = {};
      this.$rootScope.me = {
        schoolCommonRoomId: 0
      };
      this.schoolCommonRooms.splice(0, this.schoolCommonRooms.length);
    });
  }

  getAll(fromServer = false) {
    if (this.allSchoolCommonRooms.length > 0 && !fromServer) {
      return this.$q.resolve(this.allSchoolCommonRooms);
    }

    return this.$http({
      method: 'GET',
      url: '/SCR/schoolCommonRoom'
    }).then(result => {
      this.allSchoolCommonRooms = _sortBy(result.data.schoolCommonRooms, item => _toLower(item.name));
      return this.allSchoolCommonRooms;
    }, err => this.$log.error(err));
  }

  getSchoolCommonRooms(fromServer = false) {
    if (this.schoolCommonRooms.length > 0 && !fromServer) {
      return this.$q.resolve(this.schoolCommonRooms);
    }

    return this.$http({
      method: 'GET',
      url: '/SCR/user/schoolCommonRoom'
    }).then(result => {
      this.schoolCommonRooms = result.data.schoolCommonRooms;
      return this.schoolCommonRooms;
    }, err => this.$log.error(err));
  }

  getSchoolCommonRoom() {
    return this.$http({
      method: 'GET',
      url: '/SCR/schoolCommonRoom/' + this.getMySchoolCommonRoom().id
    }).then(result => {
      return result.data.schoolCommonRoom[0];
    }, err => {
      this.$log.error(err);
      this.$q.reject(err);
    });
  }

  get(id) {
    return this.$http({
      method: 'GET',
      url: '/SCR/schoolCommonRoom/' + id
    }).then(result => {
      return result.data.schoolCommonRoom[0];
    }, err => this.$q.reject(err));
  }

  add(schoolCommonRoom = {}) {
    const copySchoolCommonRoom = {};
    angular.copy(schoolCommonRoom, copySchoolCommonRoom);
    return this.$http({
      method: 'POST',
      url: '/SCR/schoolCommonRoom',
      data: {schoolCommonRoom}
    }).then(result => {
      copySchoolCommonRoom.id = result.data.id;
      copySchoolCommonRoom.disabled = false;
      this.allSchoolCommonRooms.splice(_sortedIndexBy(this.allSchoolCommonRooms, copySchoolCommonRoom, item => _toLower(item.name)), 0, copySchoolCommonRoom);
      return copySchoolCommonRoom;
    }, err => this.$q.reject(err));
  }

  edit(schoolCommonRoom = {}) {
    const copySchoolCommonRoom = {};
    angular.copy(schoolCommonRoom, copySchoolCommonRoom);
    return this.$http({
      method: 'PUT',
      url: '/SCR/schoolCommonRoom/' + schoolCommonRoom.id,
      data: {schoolCommonRoom}
    }).then(() => {
      const idx = _findIndex(this.allSchoolCommonRooms, item => item.id === schoolCommonRoom.id);
      this.allSchoolCommonRooms[idx] = schoolCommonRoom;
      return copySchoolCommonRoom;
    }, err => this.$q.reject(err));
  }

  configuration(schoolCommonRoom = {}) {
    const copySchoolCommonRoom = {};
    angular.copy(schoolCommonRoom, copySchoolCommonRoom);
    return this.$http({
      method: 'PUT',
      url: '/SCR/schoolCommonRoom/' + schoolCommonRoom.id + '/configuration',
      data: {schoolCommonRoom}
    }).then(() => {
      this.currentSchoolCommonRoom = copySchoolCommonRoom;
      this.$localStorage.mySCR = copySchoolCommonRoom;
      return copySchoolCommonRoom;
    }, err => this.$q.reject(err));
  }

  delete(id) {
    return this.$http({
      method: 'DELETE',
      url: '/SCR/schoolCommonRoom/' + id
    }).then(() => {
      _remove(this.allSchoolCommonRooms, schoolCommonRooom => schoolCommonRooom.id === id);
      return true;
    }, err => this.$q.reject(err));
  }

  updateSchoolCommonRoom(schoolCommonRoom = {}) {
    const copySchoolCommonRoom = {};
    angular.copy(schoolCommonRoom, copySchoolCommonRoom);
    return this.$http({
      method: 'PUT',
      url: '/SCR/schoolCommonRoom/' + this.getMySchoolCommonRoom().id,
      data: {schoolCommonRoom}
    }).then(() => {
      this.currentSchoolCommonRoom = copySchoolCommonRoom;
      this.$localStorage.mySCR = copySchoolCommonRoom;
      return true;
    }, err => this.$q.reject(err));
  }

  setMySchoolCommonRoom(schoolCommonRoom = {}) {
    this.$rootScope.$broadcast('scr.select', {mySCR: schoolCommonRoom});
    this.currentSchoolCommonRoom = schoolCommonRoom;
    this.$localStorage.mySCR = schoolCommonRoom;
    this.me = {};
    return schoolCommonRoom;
  }

  getMySchoolCommonRoom() {
    if (angular.isDefined(this.$localStorage.mySCR)) {
      return this.$localStorage.mySCR;
    }

    return {};
  }

  getCurrentSchoolCommonRoom() {
    if (angular.isDefined(this.$localStorage.mySCR)) {
      return this.$localStorage.mySCR;
    }

    if (_isEmpty(this.currentSchoolCommonRoom)) {
      return false;
    }

    return this.currentSchoolCommonRoom;
  }

  getId() {
    return _get(this.getCurrentSchoolCommonRoom(), 'id', null);
  }

  getUser() {
    return this.$http({
      method: 'GET',
      url: '/SCR/Me',
      params: {contextEmployee: this.me.id, contextSchoolCommonRoom: this.getMySchoolCommonRoom().id}
    }).then(result => {
      if (angular.isUndefined(result)) {
        return this.$q.reject();
      }

      this.user = result.data.me;
      this.user.schoolProject = PROJECTS.get(result.data.me.schoolProjectId) || '';
      this.$rootScope.user = this.user;
      return this.user;
    }, err => this.$q.reject(err));
  }

  getMe(fromServer = false) {
    if (this.getMePromise) {
      return this.getMePromise;
    }

    if (!_isEmpty(this.me) && !fromServer) {
      return this.$q.resolve(this.me);
    }

    if (angular.isUndefined(this.getMySchoolCommonRoom().id)) {
      return this.$q.resolve({});
    }

    this.getMePromise = this.$http({
      method: 'GET',
      url: '/SCR/schoolCommonRoom/' + this.getMySchoolCommonRoom().id + '/me'
    }).then(result => {
      this.getMePromise = null;
      this.me = result.data.me;
      this.me.roleName = this.UtilService.getRoleName(this.me.role);
      this.$rootScope.me = this.me;
      this.$localStorage.me = this.me;
      return this.me;
    }, err => {
      this.getMePromise = null;
      return this.$q.reject(err);
    });

    return this.getMePromise;
  }
}
